

import { FlexGrid, Column, CellType, CellRangeEventArgs, FormatItemEventArgs, ColumnGroupCollection, AllowSorting, CellRange, Row } from '@grapecity/wijmo.grid';
import { Globalize, hasClass } from '@grapecity/wijmo';
import { FlexGridXlsxConverter, XlsxFormatItemEventArgs } from '@grapecity/wijmo.grid.xlsx';
import _ from 'lodash';
import { Workbook } from '@grapecity/wijmo.xlsx';

import * as wjcGrid from '@grapecity/wijmo.grid';
import * as wjcCore from '@grapecity/wijmo';

// import { FlexGridXlsxConverter, XlsxFormatItemEventArgs } from 'wijmo/wijmo.grid.xlsx';
// import { HAlign } from 'wijmo/wijmo.xlsx';
// import { FlexGrid, DataMap, Column, CellType, GroupRow, FormatItemEventArgs } from 'wijmo/wijmo.grid';
// import { Globalize, hasClass } from 'wijmo/wijmo';

export type NpFlexGridEventHandler = wjcCore.IEventHandler<FlexGrid, CellRangeEventArgs>;

declare type cellTypeStr = 'None' | 'Cell' | 'ColumnHeader' | 'RowHeader' | 'TopLeft' | 'ColumnFooter' | 'BottomLeft';
export abstract class NpFlexGridUtils {

    static addEditAndPastBlockHandler(flexGrid: FlexGrid, filter: (item: any) => 'ALLOW_ALL' | 'BLOCK_ALL' | { access: 'allow' | 'block', bindings: any[] }) {
        const blockEventHandler: NpFlexGridEventHandler = (flexGird, e) => {

            if (flexGrid.columns[e.col].isReadOnly === true) {
                return;
            }

            var item = flexGird.rows[e.row].dataItem;
            if (!item) {
                return;
            }
            const fnRes = filter(item);
            if (fnRes === 'ALLOW_ALL') return;
            if (fnRes === 'BLOCK_ALL') {
                e.cancel = true;
            } else {
                const binding = e.getColumn().binding;
                if (binding == null) {
                    return;
                } else if (fnRes.access === 'allow' && !fnRes.bindings.includes(binding)) {
                    e.cancel = true;
                } else if (fnRes.access === 'block' && fnRes.bindings.includes(binding)) {
                    e.cancel = true;
                }
            }
        }
        flexGrid.beginningEdit.addHandler(blockEventHandler);
        flexGrid.pastingCell.addHandler(blockEventHandler);
    }

    static addFormatItemHandler2(flexGrid: FlexGrid, formatHander: (
        column: Column, cellType: CellType, cellTypeStr: cellTypeStr, cellEl: HTMLElement,
        binding: any, dataItem: any, g: FlexGrid, e: FormatItemEventArgs,
    ) => void) {
        flexGrid.formatItem.addHandler((g, e) => {
            const column: Column = g.columns[e.col];
            const cellTypeName: any = CellType[e.panel.cellType];
            const binding = column ? column.binding : undefined;
            // const binding = e.getColumn().binding;
            const dataItem = g.rows[e.row]?.dataItem ?? undefined;
            formatHander(column, e.panel.cellType, cellTypeName, e.cell, binding, dataItem, g, e);
        })
    };

    static addFormatItemHandler(flexGrid: FlexGrid, formatHander: (item: any, binding: any, cellEl: HTMLElement, cellType: CellType, cellTypeStr: cellTypeStr, e: FormatItemEventArgs) => void) {
        flexGrid.formatItem.addHandler((g, e) => {
            const column: Column = g.columns[e.col];
            const binding = column ? column.binding : undefined;
            // const binding = e.getColumn().binding;

            if (!g.rows[e.row] || !g.rows[e.row].dataItem) return;
            var dataItem = g.rows[e.row].dataItem;
            const cellTypeName: any = CellType[e.panel.cellType];
            formatHander(dataItem, binding, e.cell, e.panel.cellType, cellTypeName, e);
        })
    };

    static startEditingByCell(cell: any) {
        let grid: FlexGrid = cell.row.grid;
        grid.startEditing(false, cell.row.index, cell.col.index, true);
    }

    static changeCellData(cell: any, value: any) {
        let e: CellRangeEventArgs;
        let grid: FlexGrid = cell.row.grid;
        let ecv = grid.editableCollectionView;
        let item = cell.item;
        ecv.editItem(item);
        if (ecv && ecv.currentEditItem) {
            cell.item[cell.col.binding] = value;
            ecv.commitEdit();
            let e = new CellRangeEventArgs(grid.cells, grid.selection);
            grid.onRowEditEnded(e);
        }
    }

    static saveToExcel(flexGrid: FlexGrid, fileName: string, options?: {
        sheetName?: string;
        ignoreFrozen?: boolean;
        includeInvisible?: boolean;
        ignoreColumnClass?: string;
        xlsxCellFormat?: { [key: string]: any },
        formatItem?: (args: XlsxFormatItemEventArgs) => void;
    }) {


        let file = fileName;
        let sheetName = options?.sheetName || fileName;
        if (sheetName.length > 31) {
            sheetName = Globalize.format(new Date(), 'yyyyMMdd');
        }

        let ignoreColumnClass = options?.ignoreColumnClass || 'excel-ignore';

        let frozenState = { r: 0, c: 0 }

        let formatItem = options?.formatItem;
        if (!formatItem) {
            if (options?.xlsxCellFormat) {
                formatItem = NpFlexGridUtils.defaultExcelExportFormatItem(options.xlsxCellFormat);
            } else {
                formatItem = NpFlexGridUtils.defaultExcelExportFormatItem();
            }
        }

        if (options?.ignoreFrozen) {
            frozenState.r = flexGrid.frozenRows;
            frozenState.c = flexGrid.frozenColumns;
            flexGrid.frozenRows = 0;
            flexGrid.frozenColumns = 0;
        }

        let wb: Workbook = FlexGridXlsxConverter.save(flexGrid, {
            includeColumnHeaders: true,
            includeRowHeaders: false,
            includeStyles: false,
            formatItem: formatItem,
            sheetName: sheetName,
            includeColumns: (column: Column) => {
                // ignoreCssClass
                if (column.cssClass && column.cssClass.indexOf(ignoreColumnClass) >= 0) {
                    return false;
                } else if (options?.includeInvisible) {
                    // include invisible column
                    return true;
                }
                // visible
                return column.isVisible;
            }
        });

        wb.sheets[0].columns.forEach(c => c.visible = true);

        if (options?.ignoreFrozen) {
            flexGrid.frozenRows = frozenState.r;
            flexGrid.frozenColumns = frozenState.c;
        }

        wb.saveAsync(file, (base64: any) => {
        }, (reason: any) => {
            alert(reason);
        });
    }


    static defaultExcelExportFormatItem(xlsxCellFormat?: { [key: string]: any; }) {

        return function (args: XlsxFormatItemEventArgs) {

            let p = args.panel;
            let row = args.row;
            let col = args.col;
            let xlsxCell = args.xlsxCell;
            let cell: HTMLElement;
            let color: string;

            if (p.cellType === CellType.Cell) {

                let column = args.getColumn();

                // if (column.binding === 'uvw') {
                //     console.log('Type', column.dataType)
                //     console.log('Value', xlsxCell.value);
                // }

                if (column.dataType === wjcCore.DataType.Number) {

                    if (xlsxCell && xlsxCell.style) {
                        // xlsxCell.style.format = '0' // 소수점 안나옴
                        // xlsxCell.style.format = '0.#' // 소수점은 나오지만 . 이 무조건 찍힘.
                    }

                } else {
                    cell = args.getFormattedCell();
                    // xlsxCell.value = cell.textContent?.trim();
    
                    // boolean 값은 체크박스 이기 때문에 textContent 값이 없다.
                    let textContent = cell.textContent?.trim();
                    if (textContent) {
                        xlsxCell.value = textContent;
                    }

                }

                if (xlsxCellFormat) {
                    let binding = p.columns[col].binding;
                    if (binding && xlsxCellFormat[binding]) {
                        if (xlsxCell && xlsxCell.style) {
                            xlsxCell.style.format = xlsxCellFormat[binding];
                        }
                    }
                }
                //     <wj-menu-item value="0">Decimal Format</wj-menu-item>
                //     <wj-menu-item value="n2">Number Format</wj-menu-item>
                //     <wj-menu-item value="p">Percentage Format</wj-menu-item>
                //     <wj-menu-item value="c2">Currency Format</wj-menu-item>
                //     <wj-menu-separator></wj-menu-separator>
                //     <wj-menu-item value="d">Short Date</wj-menu-item>
                //     <wj-menu-item value="D">Long Date</wj-menu-item>
                //     <wj-menu-item value="f">Full Date/TIme (short time)</wj-menu-item>
                //     <wj-menu-item value="F">Full Date/TIme (long time)</wj-menu-item>
            }
        }
    }

}

// 일반 메뉴바 버튼 및 동작 정의
// static addGeneralMenuBar(flexGrid: FlexGrid, callback: () => void) {
//     flexGrid.formatItem.addHandler((s: FlexGrid, e: FormatItemEventArgs) => {
//         if (e.panel == s.topLeftCells) {
//             e.cell.innerHTML = '<i class="np-flex-grid-menu-icon"></i>';
//             // e.cell.innerHTML = '<i class="wj-grid-config fas fa-sliders-h"></i>';
//         }
//     });
//     // show the column picker when the user clicks the top-left cell
//     let ref = flexGrid.hostElement.querySelector('.wj-topleft');
//     ref.addEventListener('mousedown', (e) => {
//         if (hasClass(<Element>e.target, 'np-flex-grid-menu-icon')) {
//             callback();
//             e.preventDefault();
//         }
//     });
// }